<template>
  <qualification-list :campaign-id="this.$route.query.id" />
</template>

<script>
import QualificationList from '@/modules/notifications-log/components/QualificationList'

export default {
  name: 'CampaignQualificationsPage',

  components: {
    QualificationList
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/CampaignQualificationsPage.vue